import React from 'react'
import SavingImg1 from '../../Images/SavingImg/CompulsorySaving.jpg'
import SideNav from '../Navigation/SideNav'
import '../../css/sidenav.css'
import Aos from 'aos'

const CompulsorySaving = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>

            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNav />
                    </div>
                    <div className='d-body-main' data-aos='fade-right'>
                        <div className='saving-body-top'>
                            <h2>अनिवार्य बचत</h2>
                        </div>
                        <div className='saving-body'>
                            <div className='saving-main'>
                                <h3>विशेषताहरू :</h3>
                                <p>
                                    <ul>
                                        <li>हरेक महिनाको मसान्तभित्र नियमित रूपमा मासिक बचत गरी सक्नु पर्ने ।</li>
                                        <li>अग्र्रिम बचत बुझाउन पनि सकिने ।</li>
                                        <li>७० वर्ष उमेर पुरा भएपछि बचत खातामा भएको रकमको ७०  सो खाताको रकम जेष्ठ नागरिक बचत खातामा राखिने र ऐच्छिक बचत सरह रकम झिक्न सकिने ।</li>
                                        <li>सदस्यले अघिल्लो महिनाको अनिवार्य बचत नबुझाई पछिल्लो महिनाको बचत बुझाउन नहुने । </li>
                                        <li>मासिक बचत फिर्ता गर्दा ऋण चुक्ता नगरेसम्म बचत रकम फिर्ता नपाईने साथै ऋणीको जमानत बसेको ब्यक्तिले समेत ऋण चुक्ता नभएसम्म बचत फिर्ता नहुने । </li>
                                        <li>सदस्यले ७५ वर्ष उमेर पुगि जेष्ठ नागरिक बचत खातामा रकम सारेको अवस्थामा  खाताबन्दि शुल्क नलाग्ने ।</li>
                                        <li>सदस्यता परित्याग गर्ने सदस्यलाई खाताबन्दी शुल्क रु ५००।– लाग्ने ।</li>
                                        <li>ब्याजलाई संरक्षित पूँजी फिर्ता कोष वितरणमा गणना गरिने ।</li>
                                        <li>उत्कृष्ट बचत कर्तालाई पुरस्कार तथा सम्मान प्रदान गरिने ।</li>
                                        <li>शेयर सदस्यको घरमा प्राकृतिक प्रकोप तथा विपत्ती आई परेको अवस्थामा यस खाताबाट रकम भसक्तानी दिन बाधा पर्ने छैन ।</li>
                                        <li>शेयर सदस्य वा निजको आश्रित परिवार सदस्यमा मुटु सम्बन्धी रोग, मिर्गौला सम्बन्धी रोग, स्नायु रोग, मस्तिस्कघात, अस्थिपञ्जर सम्बन्धी रोग, कलेजो रोग, अल्जाईमर, पार्किङ्सन, क्यान्सर र पक्षघात जस्ता घातक रोगको उपचारका लागि भुक्तानी दिन बाधा पर्ने छैन ।</li>
                                        <li>रु ३०,०००।– राखि मौज्दात राखि निकाल्न सकिनेछ ।</li>
                                    </ul>
                                </p>

                            </div>
                            <div className='savingimg'>
                                <img src={SavingImg1} alt='saving-1' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default CompulsorySaving